{
  "menu": {
    "about": "Chi Siamo",
    "facilities": "Strutture",
    "villas": "Ville e Tariffe",
    "allRooms": "Tutte le Camere",
    "experiences": "Cose da Fare",
    "gallery": "Galleria",
    "news": "Notizie",
    "contact": "Contatto",
    "dining": "Cena",
    "spa": "Spa"
  },
  "cta": {
    "book": "Prenota Ora",
    "contact": "Contattaci",
    "back_to_home": "Torna alla Home",
    "read_more": "Leggi di Più"
  },
  "home": {
    "culture": {
      "subtitle": "Autentico Patrimonio Balinese",
      "title": "Esperienze Culturali",
      "desc": "Immergiti nel ricco patrimonio spirituale e culturale di Bali. Dai sacri rituali di purificazione dell'acqua all'esplorazione delle antiche tradizioni, ti guidiamo in un viaggio per scoprire la vera anima dell'isola.",
      "journeySub": "Viaggio Spirituale",
      "journeyTitle": "Purificazione a Sidemen",
      "journeyDesc": "Sperimenta un tradizionale rituale di purificazione dell'acqua balinese (Melukat) nelle sorgenti sacre di Sidemen, progettato per purificare corpo, mente e spirito.",
      "btnReserve": "Prenotazione"
    },
    "activities": {
      "subtitle": "Momenti Curati",
      "title": "Cose da Fare",
      "desc": "Offriamo le migliori attività selezionate per creare ricordi indimenticabili durante il tuo soggiorno. Immergiti nella magia di Bali, dalle emozionanti avventure alle profonde esplorazioni culturali e al benessere spirituale.",
      "btnView": "Vedi le Attività",
      "btnReserve": "Prenotazione"
    },
    "different": {
      "subtitle": "Patal Kikian Sidemen",
      "title": "Cosa Ci Rende Diversi",
      "desc": "Scopri la vera essenza di una gemma nascosta. Lontano dalla folla, offriamo un santuario isolato dove ogni dettaglio è progettato per aiutarti a disconnetterti, ricaricarti e andartene con bellissimi ricordi che durano una vita.",
      "card1": {
        "sub": "Un santuario privato lontano dal mondo",
        "title": "La Gemma Nascosta di Sidemen",
        "desc": "Nascosta lontano dal caos, la nostra villa offre la massima esclusività e privacy. Qui, non sei solo un ospite, ma un viaggiatore privilegiato che sperimenta la serenità intatta della Bali autentica."
      },
      "card2": {
        "sub": "Risveglia i tuoi sensi e ricarica la tua anima",
        "title": "Energia Rinnovata",
        "desc": "Respira l'aria fresca dei nostri lussureggianti giardini tropicali e delle vaste risaie. Ogni momento trascorso nel nostro ambiente pacifico è progettato per ringiovanire mente, corpo e spirito."
      },
      "card3": {
        "sub": "Momenti che conserverai per sempre",
        "title": "Bellissimi Ricordi",
        "desc": "Dai sorrisi sinceri alle autentiche esperienze locali, curiamo ogni dettaglio del tuo soggiorno con attenzione autentica. Torna a casa non solo riposato, ma con storie bellissime e indimenticabili da raccontare."
      }
    },
    "booking": {
      "title": "Pronto per Vivere Patal Kikian?",
      "desc": "Verifica la disponibilità e assicurati il tuo santuario privato oggi stesso."
    },
    "contact": {
      "subtitle": "Contatto",
      "title": "Come raggiungerci",
      "desc": "Che tu abbia una domanda sulle nostre camere, abbia bisogno di assistenza per la tua prenotazione o abbia una richiesta speciale per il tuo prossimo soggiorno, il nostro team di concierge dedicato è qui per aiutarti.",
      "btnEmail": "Invia un'Email",
      "btnWa": "Scrivici su WhatsApp"
    },
    "hero": {
      "subtitle": "Benvenuti alle Ville Patal Kikian",
      "title": "Risvegliati al Panorama Più Mozzafiato di Bali",
      "description": "Abbraccia la maestosa presenza del Monte Agung mentre veglia su terrazze di riso smeraldo e lussureggianti valli ondulate. Qui, nel pacifico abbraccio di Sidemen, l'aria frizzante di montagna e la serenità intatta si intrecciano per creare un santuario indimenticabile per la tua anima."
    },
    "intro": {
      "quote": "\"Per decenni, la bellezza accattivante di Sidemen ha ispirato il mondo.\"",
      "p1": "Nel 1938, il leggendario artista Walter Spies immortalò l'incantevole fascino di questa regione attraverso il suo capolavoro, <span className=\"italic text-white\">\"Morning in Iseh.\"</span> Il dipinto ha catturato magnificamente l'imponente maestosità del Monte Agung, le lussureggianti terrazze di riso smeraldo, la morbida nebbia mattutina e il ritmo pacifico della vita rurale balinese. Ad oggi, rimane un simbolo iconico dello splendore naturale di Bali.",
      "p2": "Oggi, questo stesso panorama mozzafiato si apre davanti ai tuoi occhi alle Ville Patal Kikian.",
      "p3": "Ogni mattina porta una spettacolare alba che bagna il Monte Agung di una luce dorata, illuminando ampie valli verdi e portando una fresca brezza di montagna. Qui regna la tranquillità, facendo sembrare che il tempo abbia rallentato.",
      "p4": "Al Patal Kikian, non stai semplicemente soggiornando in una villa di lusso; ti stai immergendo in quello stesso paesaggio che ha affascinato artisti, fotografi e amanti della natura da ogni angolo del globo.",
      "p5": "Offriamo un'armonia impeccabile di lusso raffinato, profondo patrimonio culturale e l'autentica bellezza naturale di Sidemen.",
      "footerQuote": "Arriva per una vacanza. Parti con ricordi che bramerai per sempre.",
      "footerBrand": "Ville Patal Kikian",
      "footerTagline": "Dove Ogni Alba Diventa un Capolavoro"
    },
    "restaurant": {
      "subtitle": "Patal Kikian Sidemen",
      "title": "Ristorante Patal Kikian",
      "desc": "Situato accanto alla nostra piscina a sfioro e all'elegante bar, il nostro ristorante offre una straordinaria esperienza culinaria incorniciata da ampie viste sulle valli verdi e sulle vaste risaie. Assapora squisite creazioni culinarias mentre la dolce brezza e i mozzafiato dintorni naturali risvegliano i tuoi sensi.",
      "callToAction": "Esplora le nostre squisite offerte culinarie. Scopri le nostre specialità locali e internazionali visualizzando il nostro menu, oppure prenota il tuo tavolo per un'esperienza culinaria indimenticabile.",
      "btnMenu": "Vedi Menu",
      "btnReserve": "Prenotazione",
      "btnTransport": "Prenotazione Trasporto Speciale",
      "btnTransportSub": "(Area di Sidemen)",
      "btnMaps": "Google Maps",
      "btnMapsSub": "Posizione"
    },
    "spa": {
      "subtitle": "Patal Kikian Sidemen",
      "title": "Spa Patal Kikian",
      "desc": "Rinvigorisci mente, corpo e anima alla Spa Patal Kikian. Sperimenta autentici rituali di guarigione balinesi e massaggi rilassanti eseguiti dai nostri abili terapisti, il tutto ammirando la mozzafiato bellezza naturale di Sidemen.",
      "callToAction": "Scopri la nostra gamma completa di trattamenti olistici. Consulta il nostro menu spa per esplorare le nostre terapie rilassanti, oppure prenota oggi stesso la tua sessione rigenerante.",
      "btnMenu": "Vedi Menu",
      "btnReserve": "Prenotazione",
      "btnTransport": "Prenotazione Trasporto Speciale",
      "btnTransportSub": "(Area di Sidemen)",
      "btnMaps": "Google Maps",
      "btnMapsSub": "Posizione"
    },
    "rooms": {
      "subtitle": "Patal Kikian Sidemen",
      "title": "Ville Patal Kikian",
      "desc": "Ogni villa è accuratamente progettata come il tuo santuario privato, con viste mozzafiato e ininterrotte del Monte Agung, vaste risaie e lussureggianti valli verdi, fondendo perfettamente il lusso con la serenità della natura."
    }
  },
  "about": {
    "hero": {
      "subtitle": "La Nostra Storia",
      "title": "Risvegliati al panorama più mozzafiato di Bali",
      "desc": "Abbraccia la maestosa presenza del Monte Agung mentre veglia sulle terrazze di riso smeraldo e le rigogliose valli. Qui, nel pacifico abbraccio di Sidemen, l'aria pura di montagna e la serenità intatta si intrecciano per creare un santuario indimenticabile.",
      "btnScroll": "Leggi Storia"
    },
    "story": {
      "p1": "Immerso ai margini di Sidemen, Karangasem, Patal Kikian Villas è più di una semplice destinazione; è un invito a vivere il vero battito del cuore di Bali. Con viste panoramiche dalla cima della collina, ogni mattina qui inizia con una sinfonia della natura: un'alba dorata che illumina l'imponente cima del Monte Agung, incorniciata da verde infinito e paesaggi incontaminati.",
      "p2": "Crediamo che il vero lusso risieda nell'armonia con la natura. Entrando nel nostro santuario, sarai avvolto dall'aria fresca e pura di montagna e da un profondo senso di tranquillità. È un luogo progettato per disconnetterti dal rumore del mondo e riconnetterti con ciò che conta davvero.",
      "subtitle": "Un'Armonia di Natura e Cultura",
      "p3": "Le nostre ville riflettono una perfetta fusione tra l'architettura tradizionale balinese e i comfort moderni, accuratamente realizzate per onorare la ricca cultura di Sidemen. Siamo orgogliosi della nostra calda e autentica ospitalità. Qui, ogni sorriso è genuino e ogni servizio viene fornito con il massimo rispetto sia per i nostri ospiti che per il nostro patrimonio locale.",
      "quote": "\"Patal Kikian Villas è il tuo paradiso nascosto: un luogo in cui paesaggi maestosi, cultura ricca e ospitalità sincera tessono un indimenticabile arazzo di ricordi.\"",
      "footer": "Non vediamo l'ora di accoglierti nel nostro santuario."
    }
  },
  "facilities": {
    "hero": {
      "subtitle": "Servizi del Resort",
      "title": "Le Nostre Strutture",
      "desc": "Scopri i nostri servizi premium progettati per offrirti comfort e relax durante tutto il tuo soggiorno a Sidemen.",
      "btnScroll": "Vedi Strutture"
    },
    "fallback": {
      "poolSub": "Oasi di Serenità",
      "poolTitle": "Piscine",
      "poolDesc1": "Immergiti nelle nostre cristalline piscine a sfioro con vista sui vibranti giardini tropicali e sulla lussureggiante valle. Che tu stia godendo una nuotata mattutina, una colazione galleggiante o semplicemente rilassandoti sotto il sole con un cocktail rinfrescante, le nostre piscine offrono lo spazio ideale per il relax.",
      "poolDesc2": "Per coloro che cercano un rifugio intimo, in alcune ville sono disponibili anche piscine private ad immersione.",
      "restSub": "Eccellenza Culinaria",
      "restTitle": "Ristorante",
      "restDesc1": "Concediti un viaggio gastronomico nel nostro esclusivo ristorante all'aperto. Siamo orgogliosi di servire l'autentica cucina balinese insieme ai piatti internazionali preferiti, tutti preparati con gli ingredienti biologici più freschi di provenienza locale.",
      "restDesc2": "Goditi la colazione gratuita, romantiche cene a lume di candela o tranquilli tè pomeridiani ammirando le viste mozzafiato della natura circostante.",
      "restBtn": "Vedi di Più",
      "spaSub": "Benessere e Guarigione",
      "spaTitle": "Spa di Lusso",
      "spaDesc1": "Rinvigorisci mente, corpo e anima nel nostro tranquillo santuario spa. Radicati nelle antiche tradizioni curative balinesi, i nostri terapisti professionisti offrono una vasta gamma di trattamenti, dai massaggi tradizionali agli scrub per il corpo e ai trattamenti per il viso rivitalizzanti.",
      "spaDesc2": "Come nostro ospite, riceverai anche un massaggio plantare gratuito di 15 minuti al tuo arrivo per lavare via istantaneamente la stanchezza del viaggio.",
      "spaBtn": "Vedi di Più"
    }
  },
  "accommodation": {
    "hero": {
      "subtitle": "Le Nostre Camere",
      "title": "Santuari di Serenità al Patal Kikian Villas",
      "desc": "Vivi la massima tranquillità nelle nostre ville accuratamente progettate, che fondono il comfort moderno con l'autenticità balinese.",
      "btnScroll": "Esplora le Camere"
    },
    "detail": {
      "loading": "Caricamento dettagli della camera...",
      "signature": "Camera Signature",
      "gallerySub": "Galleria",
      "galleryTitle": "Galleria Fotografica",
      "noImages": "Nessuna immagine disponibile per questo tipo di camera.",
      "aboutRoom": "Info sulla camera",
      "roomSize": "Dimensioni camera",
      "bedSize": "Dimensioni letto",
      "view": "Vista",
      "amenities": "Servizi",
      "inclusions": "Inclusioni",
      "pleaseNote": "Nota bene",
      "roomRules": "Regole e informazioni",
      "roomPolicy": "Politica della camera",
      "childrenPolicies": "Politiche per i bambini",
      "childrenPolicyDesc": "Sono ammessi bambini di tutte le età. I bambini fino a 5 anni (inclusi) soggiornano gratuitamente. I bambini dai 6 ai 12 anni possono soggiornare al costo di 151.250,00 IDR per bambino a notte con letto supplementare.",
      "babyCot": "Culla",
      "babyCotDesc": "I bambini fino a 2 anni (inclusi) soggiornano gratuitamente se utilizzano una culla disponibile.",
      "extraBed": "Letto supplementare",
      "extraBedDesc": "Persone di qualsiasi età soggiornano a 302.500,00 IDR a persona a notte se utilizzano un letto supplementare.",
      "noSmoking": "È vietato fumare.",
      "noPets": "Gli animali non sono ammessi.",
      "reserve": "Prenota",
      "directBooking": "Prenotazione diretta con noi",
      "bookOnBooking": "Prenota su Booking.com",
      "contactConcierge": "Contatta il nostro concierge per domande sulle prenotazioni e richieste personalizzate.",
      "otherChoices": "Altre Scelte",
      "otherRooms": "Altre camere che potrebbero piacerti",
      "bookYourStay": "Prenota il tuo soggiorno"
    }
  },
  "luxuryCard": {
    "discover": "Scopri"
  },
  "rooms": {
    "deluxe-bungalow-mountain-view": {
      "title": "Bungalow Deluxe (Vista Montagna)",
      "description": "Questo bungalow dispone di una piscina a sfioro. Dotato di ingresso privato, questo bungalow climatizzato è composto da 1 soggiorno, 1 camera da letto separata e 1 bagno con doccia e asciugacapelli. Il bungalow è arredato con scrivania e area salotto e offre minibar, set per la preparazione di tè e caffè e vista sul giardino. L'unità offre 1 letto.",
      "view": "Vista Giardino, Piscina, Montagna, Punto di riferimento e Fiume",
      "roomRules": "Fumatori: Vietato fumare. Ore di silenzio dopo le 22:00. Check-in alle 14:00, Check-out alle 12:00."
    },
    "suite-room-mountain-view": {
      "title": "Suite (Vista Montagna)",
      "description": "Gli ospiti vivranno un'esperienza speciale in quanto questa suite offre una piscina con vista. Dotata di ingresso indipendente, questa spaziosa suite è composta anche da 1 camera da letto, un'area salotto e 1 bagno con doccia e asciugacapelli. L'unità dispone di aria condizionata, vista sul giardino, terrazza e vino/champagne per gli ospiti. L'unità offre 1 letto.",
      "view": "Vista Montagna, Fiume, Punto di riferimento, Piscina e Giardino",
      "roomRules": "Fumatori: Vietato fumare. Ore di silenzio dopo le 22:00. Check-in alle 14:00, Check-out alle 12:00."
    },
    "private-pool-villa-mountain-view": {
      "title": "Villa con Piscina Privata (Vista Montagna)",
      "description": "Questa villa dispone di una piscina con vista. Dotata di ingresso indipendente, questa villa climatizzata è composta da 1 soggiorno, 1 camera da letto separata e 1 bagno con vasca e doccia. La spaziosa villa offre minibar, set per la preparazione di tè e caffè, area salotto e terrazza con vista sul giardino. L'unità offre 1 letto.",
      "view": "Vista Giardino, Piscina, Montagna e Fiume",
      "roomRules": "Fumatori: Vietato fumare. Ore di silenzio dopo le 22:00. Check-in alle 14:00, Check-out alle 12:00."
    },
    "features": {
      "Infinity Pool": "Piscina a Sfioro",
      "Mountain View": "Vista Montagna",
      "Private Balcony": "Balcone Privato",
      "Private Pool": "Piscina Privata",
      "Mount Agung View": "Vista sul Monte Agung",
      "Living Room": "Soggiorno",
      "Nature View": "Vista Natura",
      "Bedroom": "Camera da Letto"
    }
  },
  "experiences": {
    "hero": {
      "subtitle": "Cose da Fare",
      "title": "Crea I Tuoi Ricordi Migliori a Bali",
      "desc": "Da avventure mozzafiato nella natura ad esperienze culturali coinvolgenti, presentiamo una selezione curata di attività per rendere ogni momento della tua vacanza ancora più speciale.",
      "btnScroll": "Vedi Attività"
    },
    "sidebar": {
      "categories": "Categorie",
      "moreActivities": "Più Attività"
    },
    "categories": {
      "Adventure & Nature": "Avventura e Natura",
      "Culture & Art": "Cultura e Arte",
      "Wellness & Spiritual": "Benessere e Spiritualità"
    },
    "items": {
      "ATV Adventure": {
        "title": "Avventura in ATV",
        "description": "Vivi l'emozione di guidare un ATV attraverso i bellissimi paesaggi di Bali."
      },
      "Cycling Tour": {
        "title": "Tour in Bicicletta",
        "description": "Pedala attraverso lussureggianti risaie e villaggi tradizionali in una visita guidata."
      },
      "Rice Terrace Walking Tour": {
        "title": "Passeggiata nelle Risaie",
        "description": "Fai una passeggiata tranquilla attraverso alcune delle terrazze di riso più iconiche del mondo."
      },
      "Sunrise Jeep Mount Batur": {
        "title": "Alba in Jeep sul Monte Batur",
        "description": "Assisti ad un'alba mozzafiato dal Monte Batur senza l'escursione di prima mattina."
      },
      "Scooter Tour": {
        "title": "Tour in Scooter",
        "description": "Esplora le gemme nascoste di Sidemen in un emozionante tour guidato in scooter."
      },
      "Rafting": {
        "title": "Rafting",
        "description": "Vivi l'adrenalina del rafting sulle rapide lungo il fiume Ayung."
      },
      "Batur Trekking": {
        "title": "Trekking sul Monte Batur",
        "description": "Fai un'escursione sul vulcano attivo del Monte Batur e guarda l'alba dalla cima."
      },
      "Waterfall Tour": {
        "title": "Tour delle Cascate",
        "description": "Visita alcune delle cascate più belle e nascoste della zona di Sidemen."
      },
      "Swing": {
        "title": "Altalena",
        "description": "Vivi l'adrenalina di dondolare in alto sopra le meravigliose valli e giungle di Bali."
      },
      "Mount Agung Trekking": {
        "title": "Trekking sul Monte Agung",
        "description": "Mettiti alla prova con una gratificante escursione all'alba verso la vetta più alta di Bali, il Monte Agung."
      },
      "Cooking Class": {
        "title": "Corso di Cucina",
        "description": "Impara i segreti dell'autentica cucina balinese con i nostri esperti chef locali."
      },
      "Silver Class": {
        "title": "Corso dell'Argento",
        "description": "Crea i tuoi gioielli in argento unici guidati da argentieri tradizionali."
      },
      "Coffee Plantation Tour": {
        "title": "Tour della Piantagione di Caffè",
        "description": "Scopri il processo di produzione del tradizionale caffè balinese, incluso il famoso caffè Luwak."
      },
      "Yoga & Wellness": {
        "title": "Yoga e Benessere",
        "description": "Rinvigorisci la mente e il corpo con le nostre sessioni guidate di yoga e benessere."
      }
    }
  },
  "restaurant": {
    "categories": {
      "Appetizers": "Antipasti",
      "Soup": "Zuppe",
      "Pasta": "Pasta",
      "Main Course": "Piatti Principali",
      "Indonesian Food": "Cibo Indonesiano",
      "Dessert": "Dolci",
      "Beverages": "Bevande"
    },
    "hero": {
      "subtitle": "Ristorante Foresta di Foglie",
      "title": "Un Viaggio Culinario Rilassante",
      "desc": "Concediti squisite creazioni culinarie che nutrono il corpo, accompagnate dal maestoso panorama del Monte Agung...",
      "btnScroll": "Vedi Menu"
    },
    "sidebar": {
      "categories": "Categorie",
      "moreCategories": "Altre Categorie"
    },
    "backToHome": "Torna alla Home"
  },
  "spa": {
    "categories": {
      "Body Massage": "Massaggio per il Corpo",
      "Specialty Treatments": "Trattamenti Speciali",
      "Body Scrub and Mask": "Scrub e Maschera per il Corpo",
      "Facial Treatment": "Trattamento Facciale",
      "Manicure and Pedicure": "Manicure e Pedicure",
      "Spa Packages": "Pacchetti Spa"
    },
    "hero": {
      "subtitle": "Benvenuti alla Spa Patal Kikian",
      "title": "Dove il Corpo Riposa, l'Anima Ritorna",
      "desc": "La nostra spa si prende cura del tuo corpo stanco, mentre la natura lussureggiante di Sidemen abbraccia il tuo cuore...",
      "btnScroll": "Vedi Menu Spa"
    },
    "sidebar": {
      "treatments": "Trattamenti",
      "moreTreatments": "Altri Trattamenti"
    },
    "backToHome": "Torna alla Home"
  },
  "contact": {
    "hero": {
      "subtitle": "Mettiti in contatto",
      "title": "Contattaci",
      "desc": "Siamo qui per assisterti. Contattaci per richieste, prenotazioni o desideri speciali.",
      "scroll": "Contattaci"
    },
    "info": {
      "title": "Informazioni",
      "desc": "Hai una domanda o bisogno di assistenza? Il nostro team è sempre pronto ad aiutarti a pianificare il tuo soggiorno perfetto a Sidemen.",
      "address": "Jl. Raya Sidemen, Sinduwati, Sidemen, Kabupaten Karangasem, Bali 80864"
    },
    "form": {
      "title": "Inviaci un messaggio",
      "name": "Tuo Nome",
      "email": "Tua Email",
      "subject": "Soggetto",
      "message": "Messaggio",
      "btnSend": "Invia Messaggio",
      "btnSending": "Invio in corso...",
      "success": "Grazie! Il tuo messaggio è stato inviato con successo.",
      "error": "Oops! Qualcosa è andato storto. Riprova più tardi."
    }
  },
  "faq": {
    "q1": {
      "question": "A che ora è il check-in e il check-out?",
      "answer": "Il check-in è alle 14:00 e il check-out è alle 12:00 (mezzogiorno). Il check-in anticipato o il check-out posticipato sono soggetti a disponibilità e potrebbero comportare costi aggiuntivi."
    },
    "q2": {
      "question": "La colazione è inclusa nella tariffa della camera?",
      "answer": "Sì, una colazione giornaliera gratuita è inclusa in tutte le nostre prenotazioni di ville."
    },
    "q3": {
      "question": "Offrite trasferimenti aeroportuali?",
      "answer": "Sì, offriamo servizi di trasferimento aeroportuale a un costo aggiuntivo. Vi preghiamo di contattarci in anticipo per organizzare il vostro prelievo."
    },
    "q4": {
      "question": "Patal Kikian è adatto alle famiglie?",
      "answer": "Anche se diamo il benvenuto a ospiti di tutte le età, la nostra struttura è progettata come un rifugio tranquillo. I genitori devono supervisionare i bambini in ogni momento, specialmente vicino alla zona piscina."
    },
    "q5": {
      "question": "Soddisfate le restrizioni dietetiche?",
      "answer": "Assolutamente. Il nostro ristorante può soddisfare varie esigenze dietetiche, tra cui opzioni vegetariane, vegane e senza glutine. Vi preghiamo di informarci delle vostre esigenze prima dell'arrivo."
    },
    "q6": {
      "question": "Il Wi-Fi è disponibile nella villa?",
      "answer": "Sì, la connessione Wi-Fi ad alta velocità gratuita è disponibile in tutta la struttura, comprese tutte le camere e le aree pubbliche."
    },
    "subtitle": "Informazioni",
    "title": "Domande Frequenti",
    "stillHaveQuestions": "Hai ancora domande?",
    "btnContact": "Contattaci"
  },
  "terms": {
    "usage": {
      "title": "Uso del sito web",
      "p1": "Benvenuto nel nostro sito web. Continuando a navigare e utilizzare questo sito, accetti di rispettare i seguenti termini e condizioni che, insieme alla nostra politica sulla privacy, regolano il rapporto tra Patal Kikian Villas e te.",
      "p2": "Se non sei d'accordo con questi termini, ti preghiamo di non utilizzare il nostro sito web.",
      "p3": "Il contenuto delle pagine di questo sito web è solo per tua informazione generale e utilizzo. È soggetto a modifiche senza preavviso."
    },
    "booking": {
      "title": "Condizioni di Prenotazione",
      "p1_bold": "Il tuo contratto con Patal Kikian Villas:",
      "p1": "Queste Condizioni di Prenotazione formano la base del tuo contratto con Patal Kikian Villas. Effettuando una prenotazione, il primo nominativo accetta per conto di tutti di aver letto e accettato questi termini.",
      "p2_bold": "Pagamento della prenotazione:",
      "p2": "Al momento della prenotazione ti verrà richiesto di fornire i dati della carta di credito o di pagare un deposito. I no-show verranno addebitati sulla carta.",
      "p3_bold": "Precisione:",
      "p3": "Ci impegniamo a garantire che le informazioni siano accurate; tuttavia, possono verificarsi errori e ci riserviamo il diritto di correggerli."
    },
    "cancellation": {
      "title": "Politica di Cancellazione",
      "p1_bold": "Tariffe Standard:",
      "p1": "Le cancellazioni effettuate entro 14 giorni dall'arrivo comporteranno una penale pari a una notte. Le cancellazioni entro 7 giorni o il mancato arrivo comporteranno una penale del 100%.",
      "p2_bold": "Tariffe Non Rimborsabili:",
      "p2": "Le prenotazioni non rimborsabili non possono essere cancellate o modificate senza penale del 100%."
    },
    "copyright": {
      "title": "Diritto d'autore",
      "p1": "Questo sito web e il suo contenuto sono copyright di Patal Kikian Villas. Tutti i diritti riservati."
    },
    "subtitle": "Legale",
    "title": "Termini e Condizioni"
  },
  "privacy": {
    "policy": {
      "title": "Politica sulla Privacy",
      "p1": "Comprendiamo che fornirci informazioni personali comporta grande fiducia; prendiamo questa fiducia molto sul serio. Questa politica stabilisce come utilizziamo e proteggiamo le tue informazioni.",
      "p2": "Ci impegniamo a garantire la protezione della tua privacy in conformità a questa dichiarazione.",
      "p3": "Potremmo modificare questa politica di tanto in tanto aggiornando questa pagina."
    },
    "collect": {
      "title": "Cosa raccogliamo",
      "p1": "Potremmo raccogliere le seguenti informazioni:",
      "l1": "Nome e informazioni di contatto",
      "l2": "Informazioni demografiche",
      "l3": "Altre informazioni rilevanti per sondaggi e offerte",
      "l4": "L'indirizzo IP del computer"
    },
    "usage": {
      "title": "Cosa facciamo con le informazioni",
      "p1": "Richiediamo queste informazioni per comprendere le tue esigenze e fornirti un servizio migliore:",
      "l1": "Tenuta dei registri interni.",
      "l2": "Per migliorare i nostri prodotti.",
      "l3": "Per inviare email promozionali.",
      "l4": "Per personalizzare il sito web.",
      "p2": "Puoi rinunciare contattandoci all'indirizzo info@patalkikianbali.com."
    },
    "security": {
      "title": "Sicurezza",
      "p1": "Ci impegniamo a garantire che le tue informazioni siano al sicuro.",
      "p2_bold": "Informazioni Finanziarie:",
      "p2": "Non conserviamo i dati della carta di credito sui nostri server locali."
    },
    "cookies": {
      "title": "Come usiamo i cookie",
      "p1": "I cookie ci aiutano ad analizzare il traffico web. Puoi scegliere di accettare o rifiutare i cookie dal tuo browser."
    },
    "subtitle": "Legale",
    "title": "Politica sulla Privacy"
  },
  "footer": {
    "explore": "Esplorare",
    "information": "Informazione",
    "desc": "Vivi la vita serena di Sidemen. Goditi una vista spettacolare sul Monte Agung, ville di lusso e un'ospitalità calorosa perfetta per i viaggiatori in cerca di relax a Bali.",
    "translate": "Traduci",
    "quickLinks": "Link Rapidi",
    "support": "Supporto",
    "contactTitle": "Contatto",
    "contact": "Contatto",
    "faq": "FAQ",
    "terms": "Termini e Condizioni",
    "privacy": "Politica sulla Privacy",
    "whatsappUs": "Scrivici su WhatsApp",
    "allRightsReserved": "Tutti i diritti riservati.",
    "newsJournal": "Notizie e Diario"
  },
  "news": {
    "journal": "Diario",
    "latest": "Ultime Notizie e Storie",
    "subtitle": "Rimani aggiornato con le ultime notizie, storie ed eventi intorno a Patal Kikian e Sidemen.",
    "readNews": "Leggi Notizie",
    "allArticles": "Tutti gli Articoli",
    "noArticles": "Nessun articolo trovato in questa categoria.",
    "page": "Pagina",
    "of": "di"
  },
  "newsSearch": {
    "searchBreadcrumb": "Cerca",
    "searchResults": "Risultati Ricerca",
    "searchArticles": "Cerca Articoli",
    "resultsFound": "{{count}} risultati trovati",
    "forQuery": " per \"{{query}}\"",
    "placeholder": "Cerca articoli...",
    "searchBtn": "Cerca",
    "noResults": "Nessun articolo corrispondente a \"{{query}}\".",
    "enterKeyword": "Inserisci una parola chiave per cercare.",
    "backToNews": "Torna alle Notizie"
  },
  "newsCategory": {
    "category": "Categoria",
    "articlesInCat": "articoli in questa categoria",
    "noArticles": "Nessun articolo trovato in questa categoria.",
    "backToNews": "Torna alle Notizie"
  },
  "newsDetail": {
    "tags": "Tag",
    "exclusiveStay": "Soggiorno Esclusivo",
    "promoDesc": "Vivi il Lusso Premium a Sidemen",
    "bookStay": "Prenota il Tuo Soggiorno",
    "reserveStay": "Prenota Ora",
    "villaRecs": "Vacanze Consigliate",
    "recAccommodations": "Alloggi Consigliati",
    "readArticle": "Leggi Articolo",
    "search": "Cerca",
    "searchPlaceholder": "Cerca articoli...",
    "go": "Vai",
    "categories": "Categorie",
    "popularPosts": "Articoli Popolari",
    "bookNow": "Prenota Ora",
    "notFound": "Articolo Non Trovato",
    "notFoundDesc": "L'articolo che cerchi non esiste o è stato spostato.",
    "backToNews": "Torna alle Notizie"
  }
}